import clsx from 'clsx';
import {
  VirtualTableColumnDef as ColumnDef,
  ColumnDefMeta,
} from 'core/components/VirtualTable/types';
import isNil from 'lodash/isNil';

export const getTableColumnProps = <T>(
  columnDef: ColumnDef<T>,
  generalClassName?: string,
  hasSkeleton?: boolean,
): Record<string, any> => {
  const { size, meta, className, colSpan, maxSize, minSize } = columnDef;
  const autoSized = (meta as ColumnDefMeta<T>)?.autoSized ?? false;

  return {
    style: {
      width: `${size}px`,
      maxWidth: `${maxSize}px`,
      minWidth: `${minSize}px`,
      ...(isNil(colSpan) ? {} : { flex: colSpan }),
    },
    className: clsx(
      'populate-table-cell flex items-center p-1 h-full w-full',
      autoSized ? 'grow flex-1' : 'flex-initial shrink overflow-hidden',
      generalClassName,
      hasSkeleton ? '!h-8 !py-2' : className,
    ),
  };
};

export const TABLE_ROW_COMMON_CLASSES = `
populate-table-row w-full text-xs relative
flex-nowrap flex flex-row items-center justify-evenly
before:absolute before:content-[''] hover:before:block
hover:before:-top-0.5 hover:before:inset-y-0
hover:before:h-px hover:before:w-full hover:before:bg-white
`;
